import React from 'react'
import { SupplierManagementBuyerStyled } from './styled'
import {
  Button,
  Modal,
  Image,
  InputSearch,
  Paginate,
  Section,
  SelectBox,
  Table,
  Spinner,
  Input,
  Text,
  Breadcrumbs,
  Loading,
} from '../../components'
import { ICONS } from '../../themes'
import {
  ROUTE_PATH,
  STRING,
  dateMonDayYearTime,
  trimmedString,
  toastFail,
  formatNumberWithComma,
} from '../../helpers'
import FileDownload from 'js-file-download'
import { default as VARIABLES } from '../../themes/styles/variables'
import { supplierManagementBuyerController } from '../../apiService'
import { isEmpty } from 'lodash'
import { store } from 'store'
import { connect } from 'react-redux'
import {
  filterSearchInput1,
  filterSearchOptions2,
  filterSearchOptions3,
  filterSearchOptions4,
} from '../../store/actions'
import NumberFormat from 'react-number-format'
import { pageSupManagementController, rolesObj } from '../../middleware'
import { find } from 'lodash'
class SupplierManagementBuyerContainer extends React.Component {
  _isMounted = false
  constructor(props) {
    super(props)
    this.defaultOrderBy = 'asc'
    this.state = {
      options: [
        {
          accontStatus: [
            { value: 0, label: 'Active' },
            { value: 1, label: 'Inactive' },
          ],
        },
        {
          status: [
            { value: 0, label: 'All Status' },
            { value: 1, label: 'Registered' },
            { value: 3, label: 'Waiting for registration' },
            { value: 2, label: 'Not Registered' },
          ],
        },
        {
          preAssessment: [
            { value: 0, label: 'All offline assessment' },
            { value: 1, label: 'Yes' },
            { value: 2, label: 'No' },
          ],
        },
        {
          status_active: [
            { value: 0, label: 'All Active Status' },
            { value: 1, label: 'Active' },
            { value: 2, label: 'Inactive' },
          ],
        },
      ],
      isSortBy: [
        { name: 'tax_id', value: undefined },
        {
          name: 'company_name',
          value: this.defaultOrderBy,
        },
        { name: 'branch_no', value: undefined },
        { name: 'name', value: undefined },
        { name: 'email', value: undefined },
        { name: 'phone', value: undefined },
        { name: 'status', value: undefined },
        { name: 'createDate', value: undefined },
        { name: 'register_date', value: undefined },
      ],
      data: [],
      resSuplierMamagementList: {
        limit: null,
        next_page: null,
        offset: null,
        page: null,
        prev_page: null,
        records: [],
        total_page: null,
        total_record: null,
      },
      searchKeyWord: '',
      searchPage: 1,
      activePage: 1,
      sortFiedName: '',
      orderBy: 'asc',
      statusCompany: 0,
      statusActive: 0,
      isLoading: false,
      preOfflineAssessment: 0,
      sortDupActive: false,
      isModalWarningIsOpen: false,
      modalWarningInfo: {
        company_name: '',
        warning: '',
      },
      checkRole: '',
      checkMultiRole: '',
      isModalContactIsOpen: false,
      suplierById: '',
      isLoadDataModal: false,
    }
    this.fetchSupplierListDefault = this.fetchSupplierListDefault.bind(this)
    this.renderEntriePage = this.renderEntriePage.bind(this)
    this.renderPageNumber = this.renderPageNumber.bind(this)
  }

  componentDidMount() {
    this._isMounted = true
    if (this.props.enterSearchSupplierFilter) {
      this.fetchSupplierList()
    } else if (this.props.selectedOptions2) {
      this.fetchSupplierList()
    } else if (this.props.selectedOptions3) {
      this.fetchSupplierList()
    } else if (this.props.selectedOptions4) {
      this.fetchSupplierList()
    } else {
      this.fetchSupplierListDefault()
    }
    const roles = pageSupManagementController().asset()
    const multiRole = pageSupManagementController().getMultiRole()
    this.setState({
      checkRole: roles,
      checkMultiRole: multiRole,
    })
  }

  setIsLoading = (status = false) => {
    if (this._isMounted) {
      return this.setState({ isLoading: status })
    }
  }

  renderEditSup(supplierData) {
    const { checkRole, checkMultiRole } = this.state
    // const riskManangementMultiRole = find(checkMultiRole, data => {
    //   return data.id === rolesObj.risk
    // })
    // console.log(rolesObj)
    const handleClick = e => {
      return this.onClickEdit(supplierData)
    }
    let isRender = false
    if (checkMultiRole) {
      checkMultiRole.map(item => {
        if (
          item.id === rolesObj.admin ||
          item.id === rolesObj.risk ||
          item.id === rolesObj.systemadmin
        ) {
          isRender = true
        }
      })
    } else {
      if (
        checkRole === rolesObj.admin ||
        checkRole === rolesObj.risk ||
        checkRole === rolesObj.systemadmin
      ) {
        isRender = true
      }
    }

    if (isRender) {
      return (
        <Button className="link" onClick={handleClick}>
          <Image
            className="edit-icon"
            src={ICONS['icon-edit.svg']}
            alt="Edit"
            tootipValue={`Edit`}
            useTootipFor="Edit"
            useTootip={true}
          />
        </Button>
      )
    } else {
      return ''
    }
  }

  fetchSupplierList = async () => {
    try {
      this.setIsLoading(true)
      const DEFAUL_SELECTED = 0
      const DEFAUL_SORT_NAME = 'company_name'
      const params = {
        status: this.props.searchOptionFilter2 || DEFAUL_SELECTED,
        status_active: this.props.searchOptionFilter4 || DEFAUL_SELECTED,
        offline_status: this.props.searchOptionFilter3 || DEFAUL_SELECTED,
        keyWord: this.props.searchSupplierInput.trim(),
        page: this.state.activePage,
        sortName: this.state.sortFiedName || DEFAUL_SORT_NAME,
        sortBy: this.state.orderBy,
      }
      const res = await supplierManagementBuyerController().getList(params)
      if (res) {
        if (this._isMounted) {
          this.setState({
            data: res.records,
            resSuplierMamagementList: res,
            activePage: res.page ? res.page : 1,
          })
        }
        this.setIsLoading(false)
        this.findStatusDup(res.records)
      }
    } catch (error) {
      throw error
    }
  }
  fetchSupplierListDefault = async () => {
    try {
      this.setIsLoading(true)
      const DEFAUL_SELECTED = 0
      const DEFAUL_SORT_NAME = 'company_name'
      const params = {
        status: this.state.statusCompany || DEFAUL_SELECTED,
        status_active: this.state.statusActive || DEFAUL_SELECTED,
        offline_status: this.state.preOfflineAssessment || DEFAUL_SELECTED,
        keyWord: '',
        page: this.state.activePage,
        sortName: this.state.sortFiedName || DEFAUL_SORT_NAME,
        sortBy: this.state.orderBy,
      }
      const res = await supplierManagementBuyerController().getList(params)
      if (res) {
        if (this._isMounted) {
          this.setState({
            data: res.records,
            resSuplierMamagementList: res,
          })
        }
        this.setIsLoading(false)
        this.findStatusDup(res.records)
      }
    } catch (error) {
      throw error
    }
  }
  findStatusDup = data => {
    if (data) {
      const NOT_REG = 0
      const findDup = data.filter(res => res.status !== NOT_REG)
      if (findDup.length > 0) {
        if (this._isMounted) {
          return this.setState({ sortDupActive: false })
        }
      } else {
        if (this._isMounted) {
          return this.setState({ sortDupActive: true })
        }
      }
    }
  }

  findSortBy = evt => {
    let sortBy = ''
    this.state.isSortBy.find(column => {
      if (column.name === evt && column.value == undefined) {
        sortBy = 'desc'
      } else if (column.name === evt && column.value == 'asc') {
        sortBy = 'desc'
      } else if (column.name === evt && column.value == 'desc') {
        sortBy = 'asc'
      }
      return sortBy
    })
    return sortBy
  }

  toggleSort = evt => {
    const orderBy = this.findSortBy(evt)
    const sortFiedName = evt
    if (this._isMounted) {
      return this.setState(
        prevState => {
          const isSortBy = prevState.isSortBy.map(column => ({
            ...column,
            value:
              column.name === evt
                ? column.value !== undefined
                  ? column.value === 'asc'
                    ? 'desc'
                    : 'asc'
                  : 'desc'
                : undefined,
          }))
          return {
            ...prevState,
            isSortBy,
            orderBy,
            sortFiedName,
          }
        },
        () => {
          if (this.state.sortDupActive && evt === 'register_date') return
          else {
            this.fetchSupplierList()
          }
        }
      )
    }
  }

  popupWarningToggle = params => {
    let { modalWarningInfo } = this.state
    if (params) {
      modalWarningInfo = {
        company_name: params.company_name,
        warning: params.warning,
      }
    }
    if (this._isMounted) {
      return this.setState(prevState => ({
        modalWarningInfo,
        isModalWarningIsOpen: !prevState.isModalWarningIsOpen,
      }))
    }
  }

  popupContactToggle = async params => {
    this.setState({ isLoadDataModal: true })
    let { modalContactInfo } = this.state
    if (params) {
      const res = await supplierManagementBuyerController().getByID(params.id)
      // console.log(res)
      this.setState({ isLoadDataModal: false })
      if (res) {
        if (this._isMounted) {
          return this.setState(prevState => ({
            modalContactInfo,
            isModalContactIsOpen: !prevState.isModalContactIsOpen,
            suplierById: res,
          }))
        }
      } else {
        toastFail('Get supplier fail')
      }
    } else {
      this.setState({ isLoadDataModal: false })
      this.setState(prevState => ({
        isModalContactIsOpen: !prevState.isModalContactIsOpen,
      }))
      setTimeout(() => {
        this.setState({
          modalContactInfo,
          suplierById: '',
        })
      }, 500)
    }
  }

  filterSortByValue = evt => {
    return this.state.isSortBy
      .filter(columns => {
        return columns.name === evt
      })
      .map(column => column.value)[0]
  }

  matchValueSelected = (option = [], selectedId) => {
    return option.find(value => value.value === selectedId)
  }

  onClickEdit = supplierData => {
    if (supplierData) {
      this.props.history.push(
        ROUTE_PATH.SUPPLIER_MANAGEMENT_INFORMATION_EDIT.PATH +
          `:${supplierData.id}`
      )
    }
  }

  onSelectStatusCompany = value => {
    store.dispatch(filterSearchOptions2(value, true))
    if (this._isMounted) {
      return this.setState({ activePage: 1 }, () => this.fetchSupplierList())
    }
  }

  onSelectStatusActive = value => {
    store.dispatch(filterSearchOptions4(value, true))
    if (this._isMounted) {
      return this.setState({ activePage: 1 }, () => this.fetchSupplierList())
    }
  }

  onSelectPreOfflineAssessment = value => {
    store.dispatch(filterSearchOptions3(value, true))
    if (this._isMounted) {
      return this.setState({ activePage: 1 }, () => this.fetchSupplierList())
    }
  }

  onInputSearchChange = event => {
    const value = event.target.value
    store.dispatch(filterSearchInput1(value))
    // this.setState({ searchKeyWord: event.target.value })
  }

  onEnter = event => {
    if (event.key === 'Enter' && event.keyCode === 13) {
      const valueKeyword = this.props.searchSupplierInput.trim()
      store.dispatch(filterSearchInput1(valueKeyword, true))
      // this.setState(
      //   { activePage: 1, searchKeyWord: this.state.searchKeyWord.trim() },
      //   () => {
      //     this.fetchSupplierList()
      //   }
      // )
      if (this._isMounted) {
        return this.setState({ activePage: 1 }, () => {
          this.fetchSupplierList()
        })
      }
    }
  }

  cleardata = () => {
    store.dispatch(filterSearchInput1(''))
    // this.setState({ activePage: 1, searchKeyWord: '' }, () => {
    //   this.fetchSupplierList()
    // })
    if (this._isMounted) {
      return this.setState({ activePage: 1 }, () => {
        this.fetchSupplierList()
      })
    }
  }

  onPageChange = pageNumber => {
    if (this._isMounted) {
      return this.setState(
        prevState => {
          return { ...prevState, activePage: pageNumber }
        },
        () => {
          this.fetchSupplierList()
        }
      )
    }
  }

  downloadAttachment = params => {
    const funcDownloadFile = async () => {
      try {
        const { name, id } = params
        const fileData = await supplierManagementBuyerController().downloadAttachment(
          id
        )
        const { data } = fileData
        FileDownload(data, name)
      } catch (error) {
        console.log(error)
      }
    }
    funcDownloadFile()
  }

  renderStatus = statusNumber => {
    switch (statusNumber) {
      case 0:
        return <p className="not-registered-status">Not Registered</p>
      case 1:
        return <p className="apporved-status">Registered</p>
      case 2:
        return <p className="not-registered-status">Inactive</p>
      case 3:
        return <p className="wait-status">Waiting for registration</p>

      default:
        break
    }
  }

  renderTbody = (
    supplierData = {
      id: null,
      tax_id: '',
      company_name: '',
      branch: '',
      offline_assessment: '',
      status: null,
      register_date: '',
      is_deleted: null,
    }
  ) => {
    return (
      <Table.TR key={supplierData.id}>
        <Table.TD className="tax-id">
          <Text
            tootipValue={supplierData.tax_id}
            useTootipFor="tax-id"
            useTootip={true}
          >
            {supplierData.tax_id}
          </Text>
        </Table.TD>

        <Table.TD className="company-name">
          <Text
            tootipValue={supplierData.company_name}
            useTootipFor="company-name"
            useTootip={true}
          >
            {supplierData.company_name}
          </Text>
        </Table.TD>

        <Table.TD className="branch text-center">
          <div>{supplierData.branch ? supplierData.branch : 'N/A'}</div>
        </Table.TD>

        <Table.TD className="offline-comprehensive text-center">
          <div>{supplierData.offline_assessment}</div>
        </Table.TD>

        <Table.TD className="status text-center">
          {this.renderStatus(supplierData.status_supplier)}
        </Table.TD>

        <Table.TD className="register-date text-center">
          {supplierData.status_supplier === 1 ? (
            <Text
              tootipValue={dateMonDayYearTime(supplierData.register_date)}
              useTootipFor="register"
              useTootip={true}
            >
              {dateMonDayYearTime(supplierData.register_date)}
            </Text>
          ) : (
            '-'
          )}
        </Table.TD>

        <Table.TD className="actions">
          <Section>
            <Button
              className="link"
              onClick={() => this.popupContactToggle(supplierData)}
            >
              <Image
                className="supplier-sign"
                src={ICONS['icon-contact-sign.svg']}
                alt="contact sign"
              />
            </Button>
            {this.renderEditSup(supplierData)}
            {supplierData.status_supplier === 3 && (
              <Button className="link no-hover cursor">
                <Image
                  className="cursor-icon"
                  src={ICONS['icon-help.svg']}
                  alt="help"
                  tootipValue={`Invited :\n${dateMonDayYearTime(
                    supplierData.invited_date
                  )}`}
                  useTootipFor="iiiujyh"
                  useTootip={true}
                />
              </Button>
            )}

            {supplierData.status_active === 2 && (
              <Button
                className="link"
                onClick={() => this.popupWarningToggle(supplierData)}
              >
                <Image
                  className="supplier-sign"
                  src={ICONS['icon-warning-sign.svg']}
                  alt="warning sign"
                  tootipValue={`Inactive`}
                  useTootipFor="Inactive"
                  useTootip={true}
                />
              </Button>
            )}
          </Section>
        </Table.TD>
      </Table.TR>
    )
  }

  renderListSupplier = (listSupplier = []) => {
    return listSupplier.map(supplier => this.renderTbody(supplier))
  }

  renderTextNotFound = () => (
    <Table.TR>
      <Table.TD>
        <Section className="no-result-found">
          <Image src={ICONS['icon-ssr.png']} className="no-result" />
          <p>No result found</p>
        </Section>
      </Table.TD>
    </Table.TR>
  )

  renderEntriePage = (data, resSuplierMamagementList) => (
    <Section className="showing-item">
      Showing{' '}
      {data.length === 0
        ? '0'
        : formatNumberWithComma(
            Math.min(
              (resSuplierMamagementList.page - 1) *
                resSuplierMamagementList.limit +
                1
            )
          )}{' '}
      to{' '}
      {formatNumberWithComma(
        Math.min(
          resSuplierMamagementList.total_record,
          resSuplierMamagementList.limit * resSuplierMamagementList.page
        )
      )}{' '}
      of {formatNumberWithComma(resSuplierMamagementList.total_record)} entries{' '}
    </Section>
  )

  renderPageNumber = () => {
    return (
      <NumberFormat
        label="Page"
        isHorizontal
        className="paginate-moveto"
        defaultValue="1"
        maxLength="4"
        customInput={Input}
        decimalSeparator={false}
        allowNegative={false}
        allowLeadingZeros={false}
        onChange={e => {
          if (this._isMounted) {
            return this.setState({
              searchPage: parseInt(e.target.value),
            })
          }
        }}
        isAllowed={values => {
          const { value, floatValue } = values
          if (value == 0 && value !== '') {
            return false
          }
          if (
            typeof floatValue === 'undefined' ||
            typeof value === 'undefined'
          ) {
            return true
          }
          if (value.charAt(0) === '0') {
            if (value.charAt(1) && value.charAt(1) != '.') {
              return false
            }
          }
          if (this.props.maximum) {
            return floatValue <= this.props.maximum
          } else {
            return true
          }
        }}
      />
    )
  }
  renderUploadSupplier() {
    const { checkRole, checkMultiRole } = this.state
    const riskManangementMultiRole = find(checkMultiRole, data => {
      return data.id === rolesObj.risk
    })
    const handleClick = e => {
      return this.props.history.push(ROUTE_PATH.UPLOAD_SUPPLIER_FORM_BUYER.LINK)
    }
    if (
      checkRole ||
      checkRole === rolesObj.admin ||
      checkRole === rolesObj.systemadmin ||
      checkRole === rolesObj.risk ||
      checkRole === rolesObj.purchaser
    ) {
      if (checkRole === rolesObj.purchaser) {
        return ''
      } else {
        if (
          checkRole === rolesObj.admin ||
          checkRole === rolesObj.systemadmin ||
          riskManangementMultiRole ||
          checkRole === rolesObj.risk
        ) {
          return (
            <Button className="page-button" onClick={handleClick}>
              <Image src={ICONS['icon-upload.svg']} alt="add icon" />
              Upload Supplier
            </Button>
          )
        } else {
          return ''
        }
      }
    }
  }
  componentWillUnmount() {
    this._isMounted = false
  }
  render() {
    const {
      options,
      data,
      resSuplierMamagementList,
      activePage,
      isLoading,
      isModalWarningIsOpen,
      isModalContactIsOpen,
      modalWarningInfo,
      modalContactInfo,
    } = this.state
    const PlaceholderInputsearch =
      'Supplier Name, Tax ID, Supplier No., Email Contact.'
    const supplierInfo = this.state.suplierById || {}
    // console.log(supplierInfo)
    let statusCompany = ''
    switch (supplierInfo.status_company) {
      case '1':
        statusCompany = 'ยังดำเนินกิจการอยู่'
        break
      case '2':
        statusCompany = 'พิทักษ์ทรัพย์เด็ดขาด'
        break
      case '3':
        statusCompany = 'แปรสภาพ'
        break
      case '4':
        statusCompany = 'เลิก'
        break
      case '5':
        statusCompany = 'เสร็จการชำระบัญชี'
        break
      case '6':
        statusCompany = 'ควบ'
        break
      case '7':
        statusCompany = 'ถอนหนังสือบริคณห์สนธิ'
        break
      case '8':
        statusCompany = 'ร้าง'
        break
      case '9':
        statusCompany = 'ล้มละลาย'
        break
      case 'A':
        statusCompany = 'ฟื้นฟู'
        break
      case 'B':
        statusCompany = 'คืนสู่ทะเบียน'
        break
      case 'D':
        statusCompany = 'สิ้นสภาพ'
        break
      default:
    }
    return (
      <React.Fragment>
        <SupplierManagementBuyerStyled>
          {/* PAGE TITLE
          -----------------------------------------------------
          -----------------------------------------------------
          */}
          <Section className="page-topbar">
            <Section className="page-header">
              <Section className="page-icon">
                <Image
                  id="page_icon_buyer_management"
                  src={ICONS['icon-user-group-white.svg']}
                  alt="page icon"
                />
              </Section>

              <Section className="title-and-breadcrumb">
                <Section id="page_title_buyer_management" className="title">
                  {STRING.SUPPLIER_MANAGEMENT}
                </Section>
                <Breadcrumbs props={this.props} />
              </Section>
            </Section>

            <Section className="page-button">
              {this.renderUploadSupplier()}
            </Section>
          </Section>

          {/* PAGE CONTENT
          -----------------------------------------------------
          -----------------------------------------------------
          */}
          <Section className="main-content">
            <Section className="content-body">
              <Section className="table-filter">
                <InputSearch
                  type="text"
                  id="filter_search_input"
                  placeholder={PlaceholderInputsearch}
                  onChange={this.onInputSearchChange}
                  onKeyDown={event => this.onEnter(event)}
                  value={this.props.searchSupplierInput}
                  onClickSearchClear={() => this.cleardata()}
                  clear={'true'}
                />
                <SelectBox
                  id="all_status_company"
                  className="table-filter all-status"
                  options={options[1].status}
                  placeholder="All Status"
                  isSearchable={false}
                  isClearable={false}
                  onChange={event => this.onSelectStatusCompany(event.value)}
                  value={this.matchValueSelected(
                    options[1].status,
                    this.props.searchOptionFilter2
                  )}
                />
                <SelectBox
                  id="all_pre_assessment_filter"
                  className="table-filter all-pre-assessment"
                  options={options[2].preAssessment}
                  placeholder="All offline assessment"
                  isSearchable={false}
                  isClearable={false}
                  onChange={event =>
                    this.onSelectPreOfflineAssessment(event.value)
                  }
                  value={this.matchValueSelected(
                    options[2].preAssessment,
                    this.props.searchOptionFilter3
                  )}
                />
                <SelectBox
                  id="all_status_active"
                  className="table-filter all-status"
                  options={options[3].status_active}
                  placeholder="All Active Status"
                  isSearchable={false}
                  isClearable={false}
                  onChange={event => this.onSelectStatusActive(event.value)}
                  value={this.matchValueSelected(
                    options[3].status_active,
                    this.props.searchOptionFilter4
                  )}
                />
              </Section>

              <Section mt="2rem" className="table-responsive">
                <Table className="buyer split-row-color">
                  {/* Header Row */}
                  <Table.THEAD>
                    <Table.TR>
                      <Table.TH
                        className="tax-id"
                        id="tax_id_header"
                        isSortable={true}
                        sortBy={this.filterSortByValue('tax_id')}
                        onClick={() => this.toggleSort('tax_id')}
                      >
                        <div>TAX ID</div>
                      </Table.TH>

                      <Table.TH
                        className="company-name"
                        id="company_name_header"
                        isSortable={true}
                        sortBy={this.filterSortByValue('company_name')}
                        onClick={() => this.toggleSort('company_name')}
                      >
                        <div>SUPPLIER NAME</div>
                      </Table.TH>

                      <Table.TH
                        className="branch text-center"
                        id="main_directory_header"
                        isSortable={true}
                        sortBy={this.filterSortByValue('branch_no')}
                        onClick={() => this.toggleSort('branch_no')}
                      >
                        <div>BRANCH</div>
                      </Table.TH>

                      <Table.TH
                        className="offline-comprehensive text-center"
                        id="offline_comprehensive_assessment_score_header"
                      >
                        <div>Offline Comprehensive Assessment Score</div>
                      </Table.TH>

                      <Table.TH
                        className="status text-center"
                        id="status_header"
                        isSortable={true}
                        sortBy={this.filterSortByValue('status')}
                        onClick={() => this.toggleSort('status')}
                      >
                        <div>STATUS</div>
                      </Table.TH>

                      <Table.TH
                        className="register-date text-center"
                        id="registered_date_header"
                        isSortable={true}
                        sortBy={this.filterSortByValue('register_date')}
                        onClick={() => this.toggleSort('register_date')}
                      >
                        <div>REGISTERED DATE</div>
                      </Table.TH>

                      <Table.TH className="actions" id="actions_header">
                        <div>ACTIONS</div>
                      </Table.TH>
                    </Table.TR>
                  </Table.THEAD>

                  {/* Content Row */}
                  <Table.TBODY>
                    {isLoading ? (
                      <Table.TR>
                        <Table.TD>
                          <Spinner />
                        </Table.TD>
                      </Table.TR>
                    ) : (
                      this.renderListSupplier(data)
                    )}
                    {!isLoading && isEmpty(data) && this.renderTextNotFound()}
                  </Table.TBODY>
                </Table>
              </Section>
            </Section>

            <Section className="content-footer">
              {this.renderEntriePage(data, resSuplierMamagementList)}
              <Section className="paginate-wrapper">
                <Paginate
                  activePage={activePage}
                  itemsCountPerPage={resSuplierMamagementList.limit}
                  totalItemsCount={resSuplierMamagementList.total_record || 0}
                  //pageRangeDisplayed={resSuplierMamagementList.total_page}
                  onChange={pageNumber => this.onPageChange(pageNumber)}
                />

                <Section className="moveto-wrapper">
                  {this.renderPageNumber()}
                  <Button
                    disabled={
                      parseInt(this.state.searchPage) <=
                      parseInt(resSuplierMamagementList.total_page)
                        ? false
                        : true
                    }
                    onClick={() => this.onPageChange(this.state.searchPage)}
                  >
                    go
                  </Button>
                </Section>
              </Section>
            </Section>
          </Section>

          {/* MODAL CONTENT
          -----------------------------------------------------
          -----------------------------------------------------
          */}
          <Modal
            id="contact_modal"
            className="contact-modal theme-blue"
            isOpen={isModalContactIsOpen}
          >
            <Modal.Header>Contact Info</Modal.Header>

            <Modal.Body>
              <Section className="detail-groups">
                <Section className="detail-group">
                  <div className="label">{STRING.COMPANY_NAME}:</div>

                  <div className="data-control">
                    <div className="data">
                      {this.state.suplierById.company_name}
                    </div>
                  </div>
                </Section>

                <Section className="detail-group">
                  <div className="label">{STRING.COUNTRY}:</div>

                  <div className="data-control">
                    {this.state.suplierById.contact_country &&
                    this.state.suplierById.contact_country.name
                      ? this.state.suplierById.contact_country.name
                      : 'N/A'}
                  </div>
                </Section>

                <Section className="detail-group">
                  <div className="label">{STRING.TAX_ID}:</div>

                  <div className="data-control">
                    {this.state.suplierById.tax_id == '' ? (
                      <div className="data">N/A</div>
                    ) : (
                      <div className="data">
                        {this.state.suplierById.tax_id}
                      </div>
                    )}
                  </div>
                </Section>

                <Section className="detail-group">
                  <div className="label">{STRING.BRANCH}:</div>

                  {this.state.suplierById.branch == '' ? (
                    <div className="data">N/A</div>
                  ) : (
                    <div className="data">{this.state.suplierById.branch}</div>
                  )}
                </Section>

                <Section className="detail-group">
                  <div className="label">{STRING.STATUS}:</div>

                  <div className="data-control">
                    {this.state.suplierById.status_company == '' ||
                    this.state.suplierById.status_company == '0' ? (
                      <div className="data">N/A</div>
                    ) : (
                      <div className="data">{`${statusCompany}`}</div>
                    )}
                  </div>
                </Section>

                <Section className="detail-group">
                  <div className="label">{STRING.REGIS_ADDRESS}:</div>

                  <div className="data-control">
                    <div className="data">
                      {`${
                        this.state.suplierById.regis_address &&
                        this.state.suplierById.regis_address !== ''
                          ? this.state.suplierById.regis_address
                          : 'N/A'
                      }`}
                    </div>
                  </div>
                </Section>

                <Section className="detail-group">
                  <div className="label">{STRING.CONTACT_ADDRESS}:</div>

                  <div className="data-control">
                    <div className="data">
                      {`${this.state.suplierById.contact_address}`}
                    </div>
                  </div>
                </Section>

                <Section className="detail-group">
                  <div className="label">{STRING.BUSINESS_TYPE}:</div>
                  <div className="data-control">
                    {this.state.suplierById.business_type &&
                    this.state.suplierById.business_type.length > 0 ? (
                      <div className="data">
                        {this.state.suplierById.business_type.map(
                          (businessType, i) =>
                            this.state.suplierById.business_type.length ===
                            i + 1
                              ? businessType.business_type_name
                              : businessType.business_type_name + ', '
                        )}
                      </div>
                    ) : (
                      <div className="data">N/A</div>
                    )}
                  </div>
                </Section>

                <Section className="detail-group">
                  <div className="label">{STRING.YEAR_ESTABLISHED}:</div>

                  <div className="data-control">
                    <div className="data">
                      {this.state.suplierById.year_established
                        ? this.state.suplierById.year_established
                        : 'N/A'}
                    </div>
                  </div>
                </Section>

                <Section className="detail-group">
                  <div className="label">{STRING.REGISTERED_CAPITAL}:</div>

                  <div className="data-control">
                    <div className="data">
                      {this.state.suplierById.regis_capital ? (
                        <>
                          <NumberFormat
                            value={this.state.suplierById.regis_capital}
                            displayType={'text'}
                            thousandSeparator={true}
                          />
                          {` ${this.state.suplierById.currency.name}`}
                        </>
                      ) : (
                        'N/A'
                      )}
                    </div>
                  </div>
                </Section>

                <Section className="detail-group">
                  <div className="label">{STRING.SERVICE_CATEGORY}:</div>

                  <div className="data-control">
                    <div className="data">
                      {(this.state.suplierById.service_category || []).map(
                        item => (
                          <span
                            key={
                              'service_category' +
                              item.category_id +
                              item.sub_category_id
                            }
                          >
                            <div>
                              {item.category_name}&nbsp;
                              {item.sub_category_name !== '' ? '>' : null}
                              &nbsp;
                              {item.sub_category_name}
                            </div>
                          </span>
                        )
                      )}
                    </div>
                  </div>
                </Section>

                <Section className="detail-group">
                  <div className="label">{STRING.PHONE}:</div>

                  <div className="data-control">
                    <div className="data">
                      {this.state.suplierById.phone &&
                      this.state.suplierById.phone !== ''
                        ? this.state.suplierById.phone
                        : 'N/A'}
                    </div>
                  </div>
                </Section>

                <Section className="detail-group">
                  <div className="label">{STRING.FAX}:</div>

                  <div className="data-control">
                    <div className="data">
                      {this.state.suplierById.fax &&
                      this.state.suplierById.fax !== ''
                        ? this.state.suplierById.fax
                        : 'N/A'}
                    </div>
                  </div>
                </Section>

                <Section className="detail-group">
                  <div className="label">{STRING.EMAIL_LABEL}:</div>

                  <div className="data-control">
                    <div className="data">
                      {this.state.suplierById.email &&
                      this.state.suplierById.email !== ''
                        ? this.state.suplierById.email
                        : 'N/A'}
                    </div>
                  </div>
                </Section>

                <Section className="detail-group attachment">
                  <div className="label">{STRING.ATTACHMENT}:</div>

                  <div className="data-control">
                    <div className="data">
                      {supplierInfo.attachment &&
                      supplierInfo.attachment.length > 0
                        ? supplierInfo.attachment.map((e, i) => {
                            return (
                              <a
                                key={'attachment' + i}
                                href={null}
                                onClick={() => {
                                  this.downloadAttachment(e)
                                }}
                                target="_blank"
                                className="file-link"
                                rel="noopener noreferrer"
                              >
                                <span className="file-name">{e.name}</span>
                              </a>
                            )
                          })
                        : 'N/A'}
                    </div>
                  </div>
                </Section>

                <Section className="detail-group">
                  <div className="label">{STRING.CONTACT_PERSON}:</div>

                  <div className="data-control">
                    <div className="data">
                      {this.state.suplierById.contact_person &&
                      this.state.suplierById.contact_person.length !== 0
                        ? this.state.suplierById.contact_person.filter(
                            e => e.contact_is_activate === true
                          ).length > 0
                          ? this.state.suplierById.contact_person
                              .filter(e => e.contact_is_activate === true)
                              .map((e, index) => (
                                <Section
                                  key={'contact_person' + index}
                                  className="contact-person-wrapper"
                                >
                                  <div className="full-name">
                                    <Text
                                      tootipValue={e.contact_person_full_name}
                                      useTootipFor="full-name"
                                      useTootip={true}
                                    >
                                      {e.contact_person_full_name}
                                    </Text>
                                  </div>
                                  <div className="phone">
                                    <Text
                                      tootipValue={e.contact_person_phone}
                                      useTootipFor="phone"
                                      useTootip={true}
                                    >
                                      Phone: {e.contact_person_phone}
                                    </Text>
                                  </div>
                                  <div className="mail">
                                    <Text
                                      tootipValue={e.contact_person_mail}
                                      useTootipFor="mail"
                                      useTootip={true}
                                    >
                                      Email: {e.contact_person_mail}
                                    </Text>
                                  </div>
                                </Section>
                              ))
                          : 'N/A'
                        : 'N/A'}
                    </div>
                  </div>
                </Section>
              </Section>
            </Modal.Body>

            <Modal.Footer>
              <Button
                id="cancel_contact_modal"
                className="theme-border-gray close"
                onClick={() =>
                  this.state.isModalContactIsOpen
                    ? this.popupContactToggle()
                    : null
                }
              >
                {STRING.CANCEL}
              </Button>
            </Modal.Footer>
          </Modal>
        </SupplierManagementBuyerStyled>

        <Modal
          id="popup_warning_modal"
          className="popup warning theme-yellow"
          isOpen={isModalWarningIsOpen}
        >
          <Modal.Header>{modalWarningInfo.company_name}</Modal.Header>

          <Modal.Body>
            <Image src={ICONS['icon-warning.svg']} className="warning" />

            <div className="warning-msg">{modalWarningInfo.warning}</div>
          </Modal.Body>

          <Modal.Footer>
            <Button
              id="cancel_request_esg_modal"
              className="theme-border-gray close"
              onClick={() => this.popupWarningToggle()}
            >
              {STRING.CLOSE}
            </Button>
          </Modal.Footer>
        </Modal>

        <Loading loading={this.state.isLoadDataModal} />
      </React.Fragment>
    )
  }
}

const mapStateToProps = state => {
  const {
    searchSupplierInput,
    enterSearchSupplierFilter,
  } = state.searchInputFilterSupplier
  const {
    searchOptionFilter2,
    selectedOptions2,
  } = state.searchSelectOptionSupplier2
  const {
    searchOptionFilter3,
    selectedOptions3,
  } = state.searchSelectOptionSupplier3
  const {
    searchOptionFilter4,
    selectedOptions4,
  } = state.searchSelectOptionSupplier4
  return {
    searchSupplierInput,
    enterSearchSupplierFilter,
    searchOptionFilter2,
    selectedOptions2,
    searchOptionFilter3,
    selectedOptions3,
    searchOptionFilter4,
    selectedOptions4,
  }
}

const SupplierManagementBuyerContainerComponent = connect(mapStateToProps)(
  SupplierManagementBuyerContainer
)

export default SupplierManagementBuyerContainerComponent
